function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _dec, _dec2, _class, _class2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

import { Brick } from "zengular";
import twig from "./pager.twig";
import "./pager.scss";
var Pager = (_dec = Brick.register('pager', twig), _dec2 = Brick.listen('respo-change'), _dec(_class = (_class2 = /*#__PURE__*/function (_Brick) {
  _inherits(Pager, _Brick);

  var _super = _createSuper(Pager);

  function Pager() {
    _classCallCheck(this, Pager);

    return _super.apply(this, arguments);
  }

  _createClass(Pager, [{
    key: "onInitialize",
    value: function onInitialize() {
      this.pagerButtons = parseInt(this.dataset.pagerButtons);
      this.page = parseInt(this.dataset.page);
      this.pages = parseInt(this.dataset.pages);
      this.url = this.dataset.url;
      this.onlyIfNeeded = this.dataset.onlyIfNeeded === 'yes';
    }
  }, {
    key: "callback",
    value: function callback(page) {
      document.location.href = this.url.replace('{page}', page);
    }
  }, {
    key: "beforeRender",
    value: function beforeRender(args) {
      if (typeof args !== "undefined") {
        this.page = parseInt(args.page);
        this.pages = parseInt(args.pages);
        this.callback = args.callback;

        if (this.pages < 2 && this.onlyIfNeeded) {
          this.root.classList.add('hidden');
        } else {
          this.root.classList.remove('hidden');
        }
      }
    }
  }, {
    key: "createViewModel",
    value: function createViewModel() {
      var page = this.page;
      var pages = this.pages;
      var pagerButtons = this.pagerButtons;
      var viewModel = {
        page: page,
        pages: [],
        prev: page === 1 ? 1 : page - 1,
        next: page === pages ? pages : page + 1,
        last: pages
      };
      var from = page - (pagerButtons - 1) / 2;
      var to = page + (pagerButtons - 1) / 2;

      if (from < 1) {
        to += 1 - from;
        from = 1;
      }

      if (to > pages) {
        from -= to - pages;
        if (from < 1) from = 1;
        to = pages;
      }

      for (var i = from; i <= to; i++) {
        viewModel.pages.push(i);
      }

      return viewModel;
    }
  }, {
    key: "onRender",
    value: function onRender() {
      var _this = this;

      this.$$('jump').listen('click', function (event, target) {
        var page = parseInt(target.dataset.page);
        if (_this.page !== page) _this.callback(page);
      });
    }
  }, {
    key: "respochange",
    value: function respochange(event) {
      this.root.setAttribute('respo', event.data.view);
    }
  }]);

  return Pager;
}(Brick), (_applyDecoratedDescriptor(_class2.prototype, "respochange", [_dec2], Object.getOwnPropertyDescriptor(_class2.prototype, "respochange"), _class2.prototype)), _class2)) || _class);
export { Pager as default };